import * as f from '../../../components/BPMTable/BPMInputs'
import {
    DataMapper,
    DataTransformer,
    InvoiceClickStrategy,
    InvoiceDisplayStrategy,
    InvoiceSelectedActions,
    TableFieldDescription,
    ThousandSeparatorCreator,
    DateComponentCreator,
    DateDisplayCreator,
    StateComponentCreator,
    StateExcelDisplayCreator,
} from '../../../components/BPMTable/TableMapperCreator'
import {ExportFooterItemCreator} from '../../../components/BPMTable/TableFooterItems'
import TableCreatorCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreator'
import tableCreatorCreatorFactoryCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator'
import {DirectTableQueryBuilder} from "../../../components/BPMTable/TableQueryBuilder/DirectTableQueryBuilder";
import {RawUnitQueryBuilder} from "../../../components/BPMTable/TableQueryBuilder/RawUnitQueryBuilder";

let editMutator

let newMutator

let deleteMutator

const unitQuery = `
    invoice(id: $id) {
        id
        canBeValidated
        state
        domain {
            id
            name
        }
        billingRequest {
            id
            billingrequestfileSet {
                id
                driverFile {
                    extension
                    name
                }
            }
            driver{
                id
                currency{
                    code
                }
            }
        }
        account {
            id
            identifier
            description
            legalEntity {
                id
                name
            }
            validated
            provider {
                id
                name
                country{
                    name
                    id
                }
            }
        }
        identifier
        date
        dueDate
        serviceFrom
        serviceTo
        totalCost
    }
    unassignedChargeDescriptions(id: $id) {
        id
        name
    }
    unassignedDestinationDescriptions(id: $id) {
        id
        name
    }
    unassignedConcepts(id: $id) {
        id
        name
    }
    availableConcepts {
        id
        name
        technology {
            id
            name
        }
    }
    availableChargeGroups {
        id
        name
    }
    availableDestinations {
        id
        name
    }
    unassociatedServiceLinesByInvoice(id: $id)
`
const InvoiceTableCreatorQueries = {tableQueryBuilder: new DirectTableQueryBuilder('allInvoices'), editMutator, newMutator, deleteMutator, unitQueryBuilder: new RawUnitQueryBuilder(unitQuery)}

const invoiceStates = {
    'A_0': 'PENDING',
    'A_1': 'VALIDATED',
    'A_2': 'ACCEPTED',
}

class InvoiceTableCreator extends TableCreatorCreator {
    constructor(filters) {
        super(filters)
    }

    static getId = () => {
        return "InvoiceTableCreator"
    }

    getTableCreator = (tableName) => {
        const tableCreator =  this.createTableCreator(this.constructor.getId(), tableName, InvoiceTableCreatorQueries, new InvoiceClickStrategy(), new InvoiceDisplayStrategy())
        tableCreator.setSelectedRowActionsStrategy(new InvoiceSelectedActions())
        tableCreator.setTableFooterItems([new ExportFooterItemCreator()])
        tableCreator.setInitialSortField('date', 'desc')
        tableCreator.addDescriptions([
            new TableFieldDescription(
                'legalEntity',
                new DataMapper("account.legalEntity.name"),
                new f.FilterDescription(new f.TextFilter("legalEntity")),
                {label: 'Legal Entity'}
            ),
            new TableFieldDescription(
                'provider',
                new DataMapper("account.provider.name"),
                new f.FilterDescription(new f.TextFilter("provider")),
                {label: 'Vendor'}
            ),
            new TableFieldDescription(
                'country',
                new DataMapper("account.provider.country.name"),
                new f.FilterDescription(new f.TextFilter("country")),
                {label: 'Country'}
            ),
            new TableFieldDescription(
                'description',
                new DataMapper("account.description"),
                new f.FilterDescription(new f.TextFilter("description")),
                {label: 'Description'}
            ),
            new TableFieldDescription(
                'accountIdentifier',
                new DataMapper("account.identifier"),
                new f.FilterDescription(new f.TextFilter("accountIdentifier")),
                {label: 'Account ID'}
            ),
            new TableFieldDescription(
                'identifier',
                new DataMapper("identifier"),
                new f.FilterDescription(new f.TextFilter("identifier")),
                {label: 'Identifier'}
            ),
            new TableFieldDescription(
                'state',
                new DataMapper("state"),
                new f.FilterDescription(new f.InvoiceStateFilter("state")),
                {
                    label: 'State',
                    componentCreator: new StateComponentCreator(invoiceStates),
                    excelDisplay: new StateExcelDisplayCreator(invoiceStates)
                }
            ),
            new TableFieldDescription(
                'date',
                new DataMapper("date"),
                new f.FilterDescription(new f.PeriodFilter("date")),
                {label: 'Date', componentCreator: new DateComponentCreator(), excelDisplay: new DateDisplayCreator()}
            ),
            new TableFieldDescription(
                'totalCost',
                new DataMapper("totalCost"),
                new f.FilterDescription(new f.NullCreator()),
                {
                    label: 'Total Cost',
                    componentCreator:new ThousandSeparatorCreator(2),
                    excelTransform:new DataTransformer(({totalCost})=>Number(totalCost)),
                    fieldAlign: 'right',
                }
            ),
            new TableFieldDescription(
                'currency',
                new DataMapper("billingRequest.driver.currency.code"),
                new f.FilterDescription(new f.TextFilter("currency")),
                {label: 'Currency'}
            ),
            new TableFieldDescription(
                'dueDate',
                new DataMapper("dueDate"),
                new f.FilterDescription(new f.PeriodFilter("dueDate")),
                {label: 'Due Date', onlyForm: true}
            ),
            new TableFieldDescription(
                'domain',
                new DataMapper("domain.name"),
                new f.FilterDescription(new f.TextFilter("domain")),
                {label: 'Domain', onlyForm: true}
            ),
            new TableFieldDescription(
                'accountValidated',
                new DataMapper("account.validated"),
                new f.FilterDescription(new f.NullCreator()),
                {label: 'Account Validated', hidenField: true}
            ),
            new TableFieldDescription(
                'canBeValidated',
                new DataMapper("canBeValidated"),
                new f.FilterDescription(new f.NullCreator()),
                {label: 'Can Be Validated', hidenField: true}
            ),
        ])

        return tableCreator;
    }
}

tableCreatorCreatorFactoryCreator.addTableCreatorCreator(InvoiceTableCreator)

export {
    InvoiceTableCreator,
    InvoiceTableCreatorQueries
};
